export enum OtherReportType {
  SUBCONTRACTOR_DECISIONS = 'SUBCONTRACTOR_DECISIONS',
  INFRASTRUCTURES = 'INFRASTRUCTURES',
}